export const MAX_DELAYS = 3;
export const MAX_INTERRUPT = 3;

/** Senior supervisors may start a shift this many minutes before `from_datetime` (3 hours). */
export const SENIOR_SUPERVISOR_EARLY_START_MINUTES = 180;

export const SECTIONS = {
  dars: "dars",
  incidents: "incidents",
  poolaccesslogs: "poolaccesslogs",
  tennisaccesslogs: "tennisaccesslogs",
  gymaccesslogs: "gymaccesslogs",
  recreationaccesslogs: "recreationaccesslogs",
};

export const QUICK_ACTIONS_SECTIONS = [
  SECTIONS.dars,
  SECTIONS.incidents,
  SECTIONS.poolaccesslogs,
  SECTIONS.tennisaccesslogs,
  SECTIONS.gymaccesslogs,
  SECTIONS.recreationaccesslogs,
] as (keyof typeof SECTIONS)[];
